// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

h5 {
  color: var(--accent-color);
}

.wrapper {
  height: 60px;
  padding-inline: 20px;
  border-bottom: 1px solid transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
}

.venue {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding: 5px;
}
.venue h3 {
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-align: left;
  margin-bottom: 2px;
}
@media (min-width: 991px) {
  .venue h3 {
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0em;
    margin-bottom: 4px;
  }
}
.venue .change-location-block {
  display: flex;
  align-items: center;
  justify-content: center;
  position: 10px 0px;
}
.venue .change-location {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-underline-offset: 2px;
  cursor: pointer;
}
@media (min-width: 991px) {
  .venue .change-location {
    font-size: 14px;
    line-height: 16px;
  }
  .venue .change-location .location {
    display: inline-block;
    margin-right: 6px;
    height: 22px;
    width: 26px;
    vertical-align: middle;
  }
}

.logo {
  height: 25px;
  width: 190px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.action-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.action-block .btn {
  --background: var(--not-active-btn);
  min-height: 35px;
  min-width: 120px;
  --color: var(--color-black-alt);
  font-size: 12px;
  --border-width: 0px;
}
.action-block .btn:not(:last-child) {
  margin-right: 10px;
}

.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 14px 20px;
}
.venue_info_block .location {
  height: 14px;
  width: 18px;
}
@media (min-width: 991px) {
  .venue_info_block .location {
    display: none;
  }
}
@media (min-width: 991px) {
  .venue_info_block app-burger-btn {
    display: none;
  }
}
.venue_info_block h3 {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.08em;
  text-align: center;
  margin-bottom: 2px;
}
@media (min-width: 991px) {
  .venue_info_block h3 {
    font-size: 28px;
    line-height: 28px;
    letter-spacing: 0em;
    margin-bottom: 4px;
  }
}

.show-basket {
  min-width: 200px;
  position: relative;
  min-height: 35px;
}
.show-basket ion-icon {
  margin-right: 10px;
}
.show-basket:hover {
  --background: var(--primary-btn) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
  font-family: AppFontMedium;
}

.wrapper-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px 5px 10px;
}
.wrapper-mobile .logo-icon {
  width: 100px;
  height: 30px;
}

.cart-icon {
  height: 24px;
  width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header-desktop/header-desktop.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,YAAA;EACA,oBAAA;EACA,oCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AAAF;AAEE;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AChCE;ED0BA;IASC,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EACD;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;AACN;ACzDE;ED+CE;IAWI,eAAA;IACA,iBAAA;EAGN;EADM;IACE,qBAAA;IACA,iBAAA;IACA,YAAA;IACA,WAAA;IACA,sBAAA;EAGR;AACF;;AACA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAEF;AAAE;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;AAGN;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;AACF;AC5GE;EDyGD;IAKE,aAAA;EAED;AACF;ACjHE;EDkHD;IAEE,aAAA;EACD;AACF;AAEC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AC9HE;EDwHD;IASE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EACD;AACF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;AACC;EACC,kBAAA;AACF;AACE;EACE,2CAAA;AACJ;AACE;EACE,YAAA;EACA,eAAA;EACA,0BAAA;AACJ;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;AAAF;AACE;EACE,YAAA;EACA,YAAA;AACJ;;AAGA;EACE,YAAA;EACA,WAAA;AAAF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  display: block;\n}\n\nh5 {\n  color: var(--accent-color);\n}\n\n.wrapper {\n  height: 60px;\n  padding-inline: 20px;\n  border-bottom: 1px solid transparent;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n.venue {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 5px;\n\n  h3 {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\tletter-spacing: 0.08em;\n\t\ttext-align: left;\n\t\tmargin-bottom: 2px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 18px;\n\t\t\tletter-spacing: 0em;\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\t}\n  .change-location-block {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: 10px 0px;\n  }\n    .change-location {\n      font-size: 10px;\n      line-height: 12px;\n      letter-spacing: 0.08em;\n      text-align: center;\n      text-transform: uppercase;\n      text-decoration: underline;\n      text-decoration-style: solid;\n      text-underline-offset: 2px;\n      cursor: pointer;\n      @include desktop {\n        font-size: 14px;\n        line-height: 16px;\n  \n        .location {\n          display: inline-block;\n          margin-right: 6px;\n          height: 22px;\n          width: 26px;\n          vertical-align: middle;\n        }\n      }\n    }\n}\n.logo {\n  height: 25px;\n  width: 190px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.action-block {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n\n  .btn {\n    --background: var(--not-active-btn);\n    min-height: 35px;\n    min-width: 120px;\n    --color: var(--color-black-alt);\n    font-size: 12px;\n    --border-width: 0px;\n    &:not(:last-child) {\n      margin-right: 10px;\n    }\n  }\n}\n\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 24px 14px 20px;\n\n\t.location {\n\t\theight: 14px;\n\t\twidth: 18px;\n\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\tapp-burger-btn {\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\th3 {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tletter-spacing: 0.08em;\n\t\ttext-align: center;\n\t\tmargin-bottom: 2px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 28px;\n\t\t\tline-height: 28px;\n\t\t\tletter-spacing: 0em;\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\t}\n\n}\n.show-basket {\n  min-width: 200px;\n  position: relative;\n  min-height: 35px;\n\tion-icon {\n\t\tmargin-right: 10px;\n\t}\n  &:hover {\n    --background: var(--primary-btn) !important;\n  }\n  h4 {\n    color: white;\n    font-size: 14px;\n    font-family: AppFontMedium;\n  }\n}\n\n.wrapper-mobile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 20px 5px 10px;\n  .logo-icon {\n    width: 100px;\n    height: 30px;\n  }\n}\n\n.cart-icon {\n  height: 24px;\n  width: 24px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
